"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
exports.initialState = {
    config: {
        swatch1: true,
        swatch2: true,
    },
};
var reducers = (_a = {},
    _a[constants_1.SET_BACKGROUND_IMAGE_CONFIG] = function (state, action) { return (__assign(__assign({}, state), { config: action.payload })); },
    _a);
exports.default = toolkit_1.createReducer(exports.initialState, reducers);
//# sourceMappingURL=reducer.js.map